'use strict'

const cloneDeep_ = require('lodash/cloneDeep')
const noop_ = require('lodash/noop')

const addScopeToAllHandshakes = (handshakes, { componentId, itemId }) =>
  handshakes.map(handshake =>
    Object.assign({}, handshake, {
      controllerApi: handshake.controllerApi.inScope(componentId, itemId)
    })
  )

const createScopeUniqueId = (uniqueId, scopeId) =>
  [uniqueId, 'componentId', scopeId.componentId, 'itemId', scopeId.itemId].join(
    '_'
  )

module.exports = (createDataset, datasetParams) => ({
  createDetailsScope: scopeId =>
    createDataset(
      Object.assign({}, datasetParams, {
        firePlatformEvent: noop_,
        uniqueId: createScopeUniqueId(datasetParams.uniqueId, scopeId),
        isScoped: true,
        handshakes: addScopeToAllHandshakes(
          datasetParams.services().handshakes,
          scopeId
        )
      })
    ),
  createFixedItemScope: (scopeId, fixedItem) => {
    const newControllerConfig = cloneDeep_(datasetParams.controllerConfig)
    newControllerConfig.dataset.filter = datasetParams.wixDataProxy
      .filter()
      .eq('_id', fixedItem._id)
      ._build()

    return createDataset(
      Object.assign({}, datasetParams, {
        controllerConfig: newControllerConfig,
        firePlatformEvent: noop_,
        routerData: { prefetchedData: { items: [fixedItem], totalCount: 1 } },
        uniqueId: createScopeUniqueId(datasetParams.uniqueId, scopeId),
        isScoped: true,
        isFixedItem: true
      })
    )
  }
})



// WEBPACK FOOTER //
// ./dataset-controller/scopeFactory.js